import { StoreState } from "../types";
import { User } from "./types";

export const loginReducer = (state: StoreState, token: string) => {
  localStorage.setItem("token", token);

  return {
    ...state,
    token,
  };
};

export const whitelistUserReducer = (state: StoreState, whitelisted: boolean) => {
  if (whitelisted) {
    localStorage.setItem("whitelisted", "true");
  }

  return state;
};

export const logoutReducer = (state: StoreState) => {
  localStorage.clear();

  return {
    ...state,
    currentUser: new User(null),
    token: "",
  };
};

export const registerUserDetailsReducer = (
  state: StoreState,
  currentUser: User
) => {
  localStorage.setItem("userDetails", JSON.stringify(currentUser));

  return {
    ...state,
    currentUser,
  };
};
